module.exports = __webpack_public_path__ + "4c3ee5276e296bedfb13e2e283649faf.svg";